import React, { useState, useCallback, useEffect } from "react";
import SelectReact from "react-select";
import debounce from "lodash.debounce";

const MultySearchSelect = (props) => {
  const {
    form,
    field,
    searchFields = "media.translations.title",
    collectionName,
    perPage = 10,
    showFields = "",
  } = props;

  const [options, setOptions] = useState([]); // ذخیره گزینه‌های دریافتی از API
  const [loading, setLoading] = useState(false); // وضعیت لودینگ
  const [selectedItems, setSelectedItems] = useState([]); // آیتم‌های انتخاب‌شده

  // تابع برای گرفتن نتایج از API
  const fetchOptions = async (searchTerm) => {
    if (!searchTerm) return;
    setLoading(true);
    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_API_BASE_URL
        }/${collectionName}?perpage=${perPage}&page=1&search.fields=${searchFields}&search.value=${encodeURIComponent(
          searchTerm
        )}`
      );
      const data = await response.json();

      // پردازش داده‌ها برای نمایش
      if (showFields) {
        const fields = showFields.split(",");
        const processedData = data?.data?.map((item) => {
          const label = fields
            .map((field) => {
              const fieldParts = field.split(".");
              let fieldValue = item;
              fieldParts.forEach((part) => {
                fieldValue = fieldValue ? fieldValue[part] : "";
              });
              return fieldValue || "";
            })
            .join(" - ");

          return { label, value: item.id };
        });

        setOptions((prev) => [...prev, ...(processedData || [])]);
      } else {
        setOptions((prev) => [
          ...prev,
          ...(data?.data?.map((item) => ({
            label: item[searchFields] || item.id,
            value: item.id,
          })) || []),
        ]);
      }
    } catch (error) {
      console.error("Error fetching options:", error);
    } finally {
      setLoading(false);
    }
  };

  // دی‌بونسر برای کاهش تعداد درخواست‌ها
  const debouncedFetchOptions = useCallback(
    debounce((searchTerm) => {
      fetchOptions(searchTerm);
    }, 300),
    []
  );

  // مقداردهی اولیه مقادیر انتخاب‌شده
  useEffect(() => {
    if (field.value && Array.isArray(field.value)) {
      const initialSelected = field.value.map((item) => ({
        value: item.value || item, // پشتیبانی از فرمت ساده
        label: item.label || item.value || item, // تنظیم پیش‌فرض
      }));
      setSelectedItems(initialSelected);

      // اضافه کردن مقادیر اولیه به options
      setOptions((prevOptions) => {
        const newOptions = initialSelected.filter(
          (selected) =>
            !prevOptions.find((option) => option.value === selected.value)
        );
        return [...prevOptions, ...newOptions];
      });
    }
  }, [field.value]);

  const onChangeHandler = (items) => {
    setSelectedItems(items);
    form.setFieldValue(
      field.name,
      items.map((item) => ({ value: item.value, label: item.label }))
    );
  };

  return (
    <div className="text-xs col-span-2" style={{ zIndex: 0 }}>
      <label
        className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
        htmlFor={field.name}
      >
        {props.label}
      </label>
      <SelectReact
        placeholder="جستجو و انتخاب کنید..."
        isLoading={loading}
        onInputChange={debouncedFetchOptions}
        onChange={onChangeHandler}
        value={selectedItems}
        options={options}
        isMulti
        isClearable
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        noOptionsMessage={() => "موردی یافت نشد"}
      />
      <span className="text-xs text-red-400">{form.errors[field.name]}</span>
    </div>
  );
};

export default MultySearchSelect;
